import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=70e64270&scoped=true"
import script from "./TwitterIcon.vue?vue&type=script&lang=js"
export * from "./TwitterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e64270",
  null
  
)

export default component.exports